(() => {
  const currentConfig = window.localStorage.getItem('currentBundleConfig')

  if (currentConfig === null || currentConfig !== window.currentMarketBundleConfig) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          _market_bundle_config: window.currentMarketBundleConfig,
        },
        sections: 'cart-drawer'
      })
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });

        window.localStorage.setItem('currentBundleConfig', window.currentMarketBundleConfig)
      });
  }
})();